// import store from '@/store'
// const approveStatus = 1 //
// const guard = function (to, from, next) {
//     // check for valid approved user(only Farmer)
//     if (approveStatus === 1) {
//         next()
//     } else {
//         next(next({ name: 'external-user' + '.dashboard' }))
//     }`
// }
const salesCenter = (prop) => [
  {
    path: 'test',
    name: prop + '.test',
    meta: { auth: true },
    component: () => import('../views/production/pages/sales-center/test/Test.vue')
  },
  {
    path: 'dashboard',
    name: prop + '.dashboard',
    meta: { auth: true },
    component: () => import('../views/production/pages/sales-center/dashboard/List.vue')
  },
  {
    path: 'monthly-sales-report',
    name: prop + '.monthly_sales_report',
    meta: { auth: true },
    component: () => import('../views/production/pages/sales-center/monthly-sales-report/List.vue')
  },
  {
    path: 'sales-center-stock-report',
    name: prop + '.sales_center_stock_report',
    meta: { auth: true },
    component: () => import('../views/production/pages/sales-center/sales-center-stock-report/List.vue')
  },
  {
    path: 'demand-order-entry',
    name: prop + '.demand_order_entry',
    meta: { auth: true },
    component: () => import('../views/production/pages/sales-center/demand-order-entry/Form.vue')
  },
  {
    path: 'delivery-order-receive',
    name: prop + '.delivery_order_receive',
    meta: { auth: true },
    component: () => import('../views/production/pages/sales-center/delivery-order-receive/List.vue')
  },
  {
    path: 'delivery-order-receive-details',
    name: prop + '.delivery_order_receive_details',
    meta: { auth: true },
    component: () => import('../views/production/pages/sales-center/delivery-order-receive/Form.vue')
  },
  {
    path: 'sales-target-view',
    name: prop + '.sales_target_view',
    meta: { auth: true },
    component: () => import('../views/production/pages/sales-center/sales-target-view/List.vue')
  },
  {
    path: 'sales-target-details',
    name: prop + '.sales_target_details',
    meta: { auth: true },
    component: () => import('../views/production/pages/sales-center/sales-target-view/Form.vue')
  },
  {
    path: 'sales-entry',
    name: prop + '.sales_entry',
    meta: { auth: true },
    component: () => import('../views/production/pages/sales-center/sales-entry/Form.vue')
  }
]

const childRoute = (prop) => [
  {
    path: 'common/dashboard',
    name: prop + '.common_dashboard',
    meta: { auth: true },
    component: () => import('../views/CommonDashboard.vue')
  },
  {
    path: 'dashboard',
    name: prop + '.dashboard',
    meta: { auth: true },
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: 'site-pereference',
    name: prop + '.site_preference',
    meta: { auth: true },
    component: () => import('@/views/Pages/SitePreference')
  }
]
const childRoutesOne = prop => [
  {
    path: 'health-service',
    name: prop + '.health_service',
    meta: { auth: false },
    component: () => import('../views/health-public-panel/pages/health-service/Form.vue')
  },
  {
    path: 'donation-service',
    name: prop + '.donation_service',
    meta: { auth: false },
    component: () => import('../views/health-public-panel/pages/donation-service/List.vue')
  },
  {
    path: 'donation-service-x',
    name: prop + '.donation_service_x',
    meta: { auth: false },
    component: () => import('../views/health-public-panel/pages/donation-service/Form.vue')
  },
  {
    path: 'donation-service/:status',
    name: prop + '.donation_service.status',
    meta: { auth: false },
    component: () => import('../views/health-public-panel/pages/donation-service/List.vue')
  },
  {
    path: 'disability-service',
    name: prop + '.disability_service',
    meta: { auth: false },
    component: () => import('../views/health-public-panel/pages/disability-service/Form.vue')
  },
  {
    path: 'hospital-shamiti',
    name: prop + '.hospital_shamiti',
    meta: { auth: false },
    component: () => import('../views/health-public-panel/pages/samiti-form/Form.vue')
  },
  {
    path: 'hospital-shamiti-status',
    name: prop + '.hospital_shamiti_status',
    meta: { auth: false },
    component: () => import('../views/health-public-panel/pages/samiti-form/View.vue')
  },
  {
    path: 'patient-registration',
    name: prop + '.patient_registration',
    meta: { auth: false },
    component: () => import('../views/health-public-panel/pages/patient-registration/Form.vue')
  }
]

const grandPanel = prop => [
    {
        path: 'institute-registration',
        name: prop + '.institute_registration',
        meta: { auth: true },
        component: () => import('../views/grant-public-panel/pages/institution-registration/List')
    },
    {
      path: 'service-application',
      name: prop + '.service_application',
      meta: { auth: true },
      component: () => import('../views/grant-public-panel/pages/application/List')
    },
    {
      path: 'service-application/:status',
      name: prop + '.service_application',
      meta: { auth: true },
      component: () => import('../views/grant-public-panel/pages/application/List')
    },
    {
      path: 'student-entry',
      name: prop + '.student_entry',
      meta: { auth: true },
      component: () => import('../views/grant-public-panel/pages/student-entry/List')
    },
    {
      path: 'student-archive',
      name: prop + '.student_archive',
      meta: { auth: true },
      component: () => import('../views/grant-public-panel/pages/student-archive/List')
    },
    {
        path: 'add-institute',
        name: prop + '.add-institute',
        meta: { auth: true },
        component: () => import('../views/grant-public-panel/pages/institution-registration/Form')
    },
    // {
    //     path: 'view-institute/:id',
    //     name: prop + '.view-institute',
    //     meta: { auth: true },
    //     component: () => import('../views/grant-public-panel/pages/institution-registration/View')
    // },
    {
        path: 'test',
        name: prop + '.test',
        meta: { auth: true },
        component: () => import('../views/grant-public-panel/pages/institution-registration/Test')
    },
    {
        path: 'medical-treatment-form',
        name: prop + '.medical-treatment-form',
        meta: { auth: true },
        component: () => import('../views/grant-public-panel/pages/medical-treatment-new/Form')
    },
    {
        path: 'medical-treatment',
        name: prop + '.medical-treatment',
        meta: { auth: true },
        component: () => import('../views/grant-public-panel/pages/medical-treatment/List')
    },
    {
        path: 'medical-treatment-details/:id',
        name: prop + '.medical-treatment-details',
        meta: { auth: true },
        component: () => import('../views/grant-public-panel/pages/medical-treatment/View')
    },
    {
        path: 'service-tracking',
        name: prop + '.service-tracking',
        meta: { auth: true },
        component: () => import('../views/grant-public-panel/pages/service-tracking/List')
    },
    {
      path: 'received-notifications',
      name: prop + '.received_notifications',
      meta: { auth: true },
      component: () => import('../views/grant-public-panel/pages/received-notifications/List.vue')
    }
]

const grantPanel = prop => [
  {
      path: 'rehabitation',
      name: prop + '.rehabitation',
      meta: { auth: false },
      component: () => import('../views/grant-public-panel/pages/rehabitation/List.vue')
  },
  {
    path: 'rehabitation-form',
    name: prop + '.rehabitation',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/rehabitation/Form.vue')
  },
  {
    path: 'rehabitation-details',
    name: prop + '.rehabitation',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/rehabitation/Details.vue')
  },
  // medical assistance routes
  {
    path: 'medical-assistance',
    name: prop + '.medicalAssistance',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/medical-assistance/List.vue')
  },
  {
    path: 'medical-assistance-form',
    name: prop + '.medicalAssistance',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/medical-assistance/Form.vue')
  },
  {
    path: 'medical-assistance-details',
    name: prop + '.medicalAssistance',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/medical-assistance/Details.vue')
  },
  // national disability development foundation grant routes
  {
    path: 'national-disability-development-foundation-grant',
    name: prop + '.nddFoundationGrant',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/national-disability-development-foundation/List.vue')
  },
  {
    path: 'national-disability-development-foundation-grant-form',
    name: prop + '.nddFoundationGrant',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/national-disability-development-foundation/Form.vue')
  },
  {
    path: 'national-disability-development-foundation-grant-details',
    name: prop + '.nddFoundationGrant',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/national-disability-development-foundation/Details.vue')
  },
  // registered general voluntary organization routes
  {
    path: 'registered-general-voluntary-organization',
    name: prop + '.regGenVolOrg',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/registered-general-voluntary-organization/List.vue')
  },
  {
    path: 'registered-general-voluntary-organization-form',
    name: prop + '.regGenVolOrg',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/registered-general-voluntary-organization/Form.vue')
  },
  {
    path: 'registered-general-voluntary-organization-details',
    name: prop + '.regGenVolOrg',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/registered-general-voluntary-organization/Details.vue')
  },
  // special grant routes
  {
    path: 'special-grant',
    name: prop + '.specialGrant',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/special-grant/List.vue')
  },
  {
    path: 'special-grant-form',
    name: prop + '.specialGrant',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/special-grant/Form.vue')
  },
  {
    path: 'special-grant-details',
    name: prop + '.specialGrant',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/special-grant/Details.vue')
  },
  {
    path: 'scholarship-shishu-paribar',
    name: prop + '.scholarship_shishu_paribar',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/scholarship-shishu-paribar/List.vue')
  },
  {
    path: 'scholarship-shishu-paribar-form',
    name: prop + '.scholarship_shishu_paribar_form',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/scholarship-shishu-paribar/Form.vue')
  },
  {
    path: 'scholarship-shishu-paribar-details/:id',
    name: prop + '.scholarship_shishu_paribar_details',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/scholarship-shishu-paribar/Details.vue')
  },
  {
    path: 'orphanage',
    name: prop + '.orphanage',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/private-orphanage/List.vue')
  },
  {
    path: 'orphanage-form',
    name: prop + '.orphanage',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/private-orphanage/Form.vue')
  },
  {
    path: 'orphanage-details',
    name: prop + '.orphanage',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/private-orphanage/Details.vue')
  },
  {
    path: 'national-disability-development-foundation-grant-personal',
    name: prop + '.nddfg_personal',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/grant-personal-disability-foundation/List.vue')
  },
  {
    path: 'national-disability-development-foundation-grant-personal-form',
    name: prop + '.nddfg_personal_form',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/grant-personal-disability-foundation/Form.vue')
  },
  {
    path: 'national-disability-development-foundation-grant-personal-details/:id',
    name: prop + '.nddfg_personal_details',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/grant-personal-disability-foundation/Details.vue')
  },
  {
    path: 'criminal-rehabilitation-association',
    name: prop + '.criminal_rehabilitation_association',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/correction-of-offender-grant/List.vue')
  },
  {
    path: 'criminal-rehabilitation-association-form',
    name: prop + '.criminal_rehabilitation_association_form',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/correction-of-offender-grant/Form.vue')
  },
  {
    path: 'service-application-form',
    name: prop + '.service_application_form',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/application/Form.vue')
  },
  {
    path: 'service-application-nid',
    name: prop + '.service_application_nid',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/application/Nid.vue')
  },
  // {
  //   path: 'criminal-rehabilitation-association-details/:id',
  //   name: prop + '.criminal_rehabilitation_association_details',
  //   meta: { auth: false },
  //   component: () => import('../views/grant-public-panel/pages/correction-of-offender/Details.vue')
  // },
  {
    path: 'patient-welfare-assoc',
    name: prop + '.patient-welfare-assoc',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/patient-welfare-assoc/List.vue')
  },
  {
    path: 'patient-welfare-assoc-form',
    name: prop + '.patient-welfare-assoc-form',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/patient-welfare-assoc/Form.vue')
  },
  {
    path: 'patient-welfare-assoc-details',
    name: prop + '.patient-welfare-assoc-details',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/patient-welfare-assoc/Details.vue')
  },
  {
    path: 'ucd-development',
    name: prop + '.ucd-development',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/coordination-council-grant/List.vue')
  },
  {
    path: 'ucd-development-form',
    name: prop + '.ucd-development-form',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/coordination-council-grant/Form.vue')
  },
  {
    path: 'ucd-development-details',
    name: prop + '.ucd-development-details',
    meta: { auth: false },
    component: () => import('../views/grant-public-panel/pages/ucd-development/Details.vue')
  },
  {
      path: 'national-level-grant-form',
      name: prop + '.national_level_grant_form',
      meta: { auth: true },
      component: () => import('../views/grant-public-panel/pages/national-level-grant/Form')
  },
  {
      path: 'national-level-grant',
      name: prop + '.national_level_grant',
      meta: { auth: true },
      component: () => import('../views/grant-public-panel/pages/national-level-grant/List')
  }
  // {
  //     path: 'coordination-council-grant-form',
  //     name: prop + '.coordination_council_grant_form',
  //     meta: { auth: true },
  //     component: () => import('../views/grant-public-panel/pages/coordination-council-grant/Form')
  // },
  // {
  //     path: 'coordination-council-grant',
  //     name: prop + '.coordination_council_grant',
  //     meta: { auth: true },
  //     component: () => import('../views/grant-public-panel/pages/coordination-council-grant/List')
  // },
  // {
  //     path: 'correction-of-offender-grant-form',
  //     name: prop + '.correction_of_offender_grant_form',
  //     meta: { auth: true },
  //     component: () => import('../views/grant-public-panel/pages/correction-of-offender-grant/Form')
  // },
  // {
  //     path: 'correction-of-offender-grant',
  //     name: prop + '.correction_of_offender_grant',
  //     meta: { auth: true },
  //     component: () => import('../views/grant-public-panel/pages/correction-of-offender-grant/List')
  // }
]
const dealerPanel = (prop) => [
  {
    path: 'Profile',
    name: prop + '.profile',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/profile/List.vue')
  },
  {
    path: 'registration-list',
    name: prop + '.registration_list',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/registration-list/List.vue')
  },
  {
    path: 'profile-edit',
    name: prop + '.profile_edit',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/profile/Form.vue')
  },
  {
    path: 'demand-order-entry',
    name: prop + '.demand_order_entry',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/demand-order-entry/Form.vue')
  },
  {
    path: 'demand-order-list',
    name: prop + '.demand_order_list',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/demand-order-entry/List.vue')
  },
  {
    path: 'quotation-receive',
    name: prop + '.quotation_receive',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/quotation-receive/List.vue')
  },
  {
    path: 'delivery-order-receive',
    name: prop + '.delivery_order_receive',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/delivery-order-receive/List.vue')
  },
  {
    path: 'delivery-order-received-list',
    name: prop + '.delivery_order_received_list',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/delivery-order-received-list/List.vue')
  },
  {
    path: 'delivery-product-return',
    name: prop + '.delivery_product_return',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/return-product/List.vue')
  },
  {
    path: 'payment',
    name: prop + '.payment',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/payment/List.vue')
  },
  {
    path: 'payment/:status',
    name: prop + '.payment',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/payment/List.vue')
  },
  {
    path: 'promotion-view',
    name: prop + '.promotion_view',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/promotion-view/List.vue')
  },
  {
    path: 'promotion-dashboard',
    name: prop + '.promotion_dashboard',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/promotion-dashboard/List.vue')
  },
  {
    path: 'received-notifications',
    name: prop + '.received_notifications',
    meta: { auth: true },
    component: () => import('../views/production/pages/dealer-panel/received-notifications/List.vue')
  }
]
const patientPanel = prop => [
  {
    path: 'dashboard',
    name: prop + '.dashboard',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/Dashboard.vue')
  },
  {
    path: 'profile',
    name: prop + '.profile',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/profile/Details.vue')
  },
  {
    path: 'profile-edit',
    name: prop + '.profile_edit',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/profile/Form.vue')
  },
  {
    path: 'view-resume',
    name: prop + '.view_resume',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/view-resume/Form.vue')
  },
  {
    path: 'resume',
    name: prop + '.resume',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/resume/Form.vue')
  },
  {
    path: 'wish-list',
    name: prop + '.wish_list',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/wish-list/List.vue')
  },
  {
    path: 'notification-awareness',
    name: prop + '.notification_awareness',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/notification-awareness/List.vue')
  },
  {
    path: 'apply-for-device',
    name: prop + '.apply_for_device',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/apply-for-device/List.vue')
  },
  {
    path: 'apply-for-device-form',
    name: prop + '.apply_for_device',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/apply-for-device/Form.vue')
  },
  {
    path: 'apply-for-job',
    name: prop + '.apply_for_job',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/apply-for-job/List.vue')
  },
  {
    path: 'apply-for-job-details',
    name: prop + '.apply_for_job_details',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/apply-for-job/Details.vue')
  },
  {
    path: 'job-confirmation-list',
    name: prop + '.job_confirmation_list',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/job-confirmation-list/List.vue')
  },
  {
    path: 'Event-list',
    name: prop + '.event_list',
    meta: { auth: true },
    component: () => import('../views/patient-panel/pages/event-list/List.vue')
  }
]
const stallParticipant = prop => [
  {
    path: 'dashboard',
    name: prop + '.dashboard',
    meta: { auth: true },
    component: () => import('../views/stall-participant/pages/Dashboard.vue')
  },
  {
    path: 'apply-form',
    name: prop + '.apply-form',
    meta: { auth: true },
    component: () => import('../views/stall-participant/pages/Form.vue')
  },
  {
    path: 'profile',
    name: prop + '.profile',
    meta: { auth: true },
    component: () => import('../views/stall-participant/pages/profile/Details.vue')
  },
  {
    path: 'profile-update',
    name: prop + '.profile_update',
    meta: { auth: true },
    component: () => import('../views/stall-participant/pages/profile/Form.vue')
  },
  {
    path: 'apply-stall-form',
    name: prop + '.apply_stall_form',
    meta: { auth: true },
    component: () => import('../views/stall-participant/pages/apply-for-stall/Form.vue')
  },
  {
    path: 'apply-stall-list',
    name: prop + '.apply_stall_list',
    meta: { auth: true },
    component: () => import('../views/stall-participant/pages/apply-for-stall/List.vue')
  },
  {
    path: 'apply-stall-list/:status',
    name: prop + '.apply_stall_list.status',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../views/stall-participant/pages/apply-for-stall/List.vue')
  },
  {
    path: 'e-certificate',
    name: prop + '.e_certificate',
    meta: { auth: true },
    component: () => import('../views/stall-participant/pages/e-certificate/List.vue')
  },
  {
    path: 'event-summary-report',
    name: prop + '.event_summary_report',
    meta: { auth: true },
    component: () => import('../views/stall-participant/pages/event-summary-report/List.vue')
  }
]
const trainingLearning = prop => [
    {
        path: 'profile',
        name: prop + '.profile',
        meta: { auth: true },
        component: () => import('../views/training-panel/pages/profile/List.vue')
    },
    {
        path: 'profile-update',
        name: prop + '.profile_update',
        meta: { auth: true },
        props: true,
        component: () => import('../views/training-panel/pages/profile/Form.vue')
    },
    {
        path: 'circular',
        name: prop + '.circular',
        meta: { auth: true },
        component: () => import('../views/training-panel/pages/circular/List.vue')
    },
    {
        path: 'enrollment',
        name: prop + '.enrollment',
        meta: { auth: true },
        component: () => import('../views/training-panel/pages/enrollment/List.vue')
    },
    {
        path: 'certificate',
        name: prop + '.certificate',
        meta: { auth: true },
        component: () => import('../views/training-panel/pages/certificate/List.vue')
    },
    {
        path: 'routine',
        name: prop + '.routine',
        meta: { auth: true },
        component: () => import('../views/training-panel/pages/schedule/List.vue')
    },
    {
        path: 'doc-request',
        name: prop + '.doc-request',
        meta: { auth: true },
        component: () => import('../views/training-panel/pages/doc-request/List.vue')
    },
    {
        path: 'complain',
        name: prop + '.complain',
        meta: { auth: true },
        component: () => import('../views/training-panel/pages/complain/List.vue')
    },
    {
        path: 'faq',
        name: prop + '.faq',
        meta: { auth: true },
        component: () => import('../views/training-panel/pages/faq/List.vue')
    },
    {
        path: 'trainer-evaluation',
        name: prop + '.trainer_evaluation',
        meta: { auth: true },
        component: () => import('../views/training-panel/pages/trainer-evaluation/List.vue')
    },
    {
        path: 'trainer-evaluation-entry',
        name: prop + '.trainer_evaluation_entry',
        meta: { auth: true },
        component: () => import('../views/training-panel/pages/trainer-evaluation/Form.vue')
    },
    {
      path: 'received-notifications',
      name: prop + '.received_notifications',
      meta: { auth: true },
      component: () => import('../views/training-panel/pages/received-notifications/List.vue')
    }
]

const employerPanel = prop => [
  {
    path: 'dashboard',
    name: prop + '.dashboard',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/Dashboard.vue')
  },
  {
    path: 'profile',
    name: prop + '.profile',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/profile/Details.vue')
  },
  {
    path: 'job-fair-circular',
    name: prop + '.job_fair_circular',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/job-fair-circular/List.vue')
  },
  {
    path: 'job-fair-circulation-details',
    name: prop + '.job_fair_circular_view',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/job-fair-circular/Details.vue')
  },
  {
    path: 'profile-edit',
    name: prop + '.profile_edit',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/profile/Form.vue')
  },
  {
    path: 'candidate-applicant-list',
    name: prop + '.candidate_applicant_list',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/candidate-applicant-list/List.vue')
  },
  {
    path: 'applicant-cv-view',
    name: prop + '.applicant_cv_view',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/candidate-applicant-list/Details.vue')
  },
  {
    path: 'sorting-application',
    name: prop + '.sorting_application',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/sorting-application/List.vue')
  },
  {
    path: 'cv-view',
    name: prop + '.cv_view',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/sorting-application/Details.vue')
  },
  {
    path: 'sorting-application-form',
    name: prop + '.sorting_application_form',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/sorting-application/Form.vue')
  },
  {
    path: 'confirmation-list',
    name: prop + '.confirmation_list',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/confirmation-list/List.vue')
  },
  {
    path: 'confirm-cv-view',
    name: prop + '.confirm_cv_view',
    meta: { auth: true },
    component: () => import('../views/employer-panel/pages/confirmation-list/Details.vue')
  }
]
const routes = [
  {
    path: '/',
    name: 'external-user',
    component: () => import('@/layouts/ExternalUserLayout.vue'),
    meta: { auth: true },
    children: childRoute('external-user')
  },
  {
    path: '/sales-center',
    name: 'external_user.sales_center',
    component: () => import('@/layouts/ExternalProductionLayout.vue'),
    meta: { auth: false },
    children: salesCenter('external_user.sales_center')
  },
  {
        path: '/grant-panel',
        name: 'external_user.grant_panel',
        component: () => import('@/layouts/ExternalGrantLayout.vue'),
        meta: { auth: false },
        children: grandPanel('external_user.grant_panel')
  },
  // health public panel
  {
    path: '/portal/hospital-service-panel',
    name: 'portal.hospital_service_panel',
    component: () => import('@/layouts/HealthPublicDashboard.vue'),
    meta: { auth: false }
  },
  // disability public panel
  {
    path: '/portal/disability-service-panel',
    name: 'portal.disability_service_panel',
    component: () => import('@/layouts/DisabilityPublicDashboard.vue'),
    meta: { auth: false }
  },
  {
    path: '/portal/hospital-service',
    name: 'portal.hospital_service',
    component: () => import('@/layouts/HealthPublicLayout.vue'),
    meta: { auth: false },
    children: childRoutesOne('portal.hospital_service')
  },
  // grant public panel
  {
    path: '/grant-public-panel',
    name: 'grant_public_panel',
    component: () => import('@/layouts/ExternalGrantLayout.vue'),
    meta: { auth: false },
    children: grantPanel('grant-service')
  },
  {
    path: '/dealer-panel',
    name: 'external_user.dealer_panel',
    component: () => import('@/layouts/ExternalProductionLayout.vue'),
    meta: { auth: false },
    children: dealerPanel('external_user.dealer_panel')
  },
  // patient panel
  {
    path: '/patient-panel',
    name: 'external_user.patient_panel',
    component: () => import('@/layouts/ExternalPatientLayout.vue'),
    meta: { auth: false },
    children: patientPanel('external_user.patient_panel')
  },
  {
    path: '/stall-participant',
    name: 'external_user.stall_participant',
    component: () => import('@/layouts/ExternalStallLayout.vue'),
    meta: { auth: false },
    children: stallParticipant('external_user.stall_participant')
  },
  {
    path: '/employer-panel',
    name: 'external_user.employer_panel',
    component: () => import('@/layouts/ExternalEmployerLayout.vue'),
    meta: { auth: false },
    children: employerPanel('external_user.employer_panel')
  },
  {
      path: '/training-panel',
      name: 'external_user.training_panel',
      component: () => import('@/layouts/ExternalTrainingLayout.vue'),
      meta: { auth: false },
      children: trainingLearning('external_user.training_panel')
  }
]

export default routes
